function ss_product_personalization(label_id) {
  // If label_id is set, update the image for that specific element
  if (label_id) {
    ss_product_personalization_update_image(label_id);
  } else {
    // If label_id is not set, loop through all elements with IDs starting with 'ss-product-personalization-'
    $('select[id^="ss-product-personalization-"]').each(function () {
      var currentId = $(this).attr("id");
      ss_product_personalization_update_image(currentId);
    });
  }
  ss_product_personalization_calculate();
}

function ss_product_personalization_update_image(selectId) {
  if ($("#" + selectId).is("select")) {
    var selectedImage = $("#" + selectId + " option:selected").data("image");
    var selectedValue = $("#" + selectId + " option:selected").val();
    var imageElement = $("#" + selectId + "-image");

    if (selectedImage) {
      // If there is an image for the selected option, update the image element
      imageElement.attr("src", selectedImage);
      imageElement.off("click").on("click", function () {
        ss_lightbox(selectedImage, selectedValue);
      });
      imageElement.show();
    } else {
      // If there is no image attribute, hide the image element
      imageElement.hide();
    }
  }
}

function ss_product_personalization_calculate() {
  var price = 0; // Initialize the price variable

  $(
    'select[id^="ss-product-personalization-"], input[id^="ss-product-personalization-"], textarea[id^="ss-product-personalization-"]'
  ).each(function () {
    var elementType = $(this).prop("tagName").toLowerCase(); // This will give 'select', 'input', or 'textarea'

    switch (elementType) {
      case "select":
        // Handle select elements
        var selectedOption = $(this).find("option:selected");
        // Add price from the select element itself if it has a data-price attribute
        if ($(this).data("price")) {
          price += parseFloat($(this).data("price"));
        }
        // Add price from the selected option if it has a data-price attribute
        if (selectedOption.length && selectedOption.data("price")) {
          price += parseFloat(selectedOption.data("price"));
        }
        break;

      case "textarea":
        // Handle textarea elements
        if ($(this).val() && $(this).data("price")) {
          price += parseFloat($(this).data("price"));
        }
        break;

      default:
        // Handle input elements
        if ($(this).prop('type') == 'radio') {
          if ($(this).is(':checked') && $(this).data("price")) {
            price += parseFloat($(this).data("price"));
          }
        } else {
          if ($(this).val() && $(this).data("price")) {
            price += parseFloat($(this).data("price"));
          }
        }
        break;
    }
  });

  // After the loop, you can do something with the accumulated price
  ss_product_personalization_click_price(price);
}

function ss_product_personalization_click_price(price) {
  // Find the fieldset with the legend title "Personalization Total"
  var fieldset = $('legend:contains("Personalization Total")').parent(
    "fieldset"
  );

  // Find the input with the specified value within this fieldset and get its id
  var inputId = fieldset.find('input[value="' + price + '"]').attr("id");

  // If the id is found within the fieldset, trigger a click on the label for that input
  if (inputId) {
    $('label[for="' + inputId + '"]').click();
  }
}

$(document).ready(function () {
  ss_product_personalization();

  $(".ss-product-personalization-popup-gallery").each(function () {
    ss_gallery(this);
  });
});

document.addEventListener("on:quickbuy:after-open", (event) => {
  $(".ss-product-personalization-popup-gallery").each(function () {
    ss_gallery(this);
  });
});
